import dealerInfo from './dealerInfo';
import contactInfo from './contactInfo';

const root = {
	dealerInfo,
	contactInfo
};

export default root;
